<template>
  <div class="entity-analysis">
      <EntityAnalysis ref="ea" v-bind:showResults="false" :disableTextArea="true" :textAreaClass="1" />
  </div>
</template>

<script>
  //using Jquery in vue is gross but 'eh
  import $ from 'jquery';
  require('../lib/typtype');
  import EntityAnalysis from '../components/EntityAnalysis'

  export default {
    name: 'EntityAnalysisDemo',
    components: {
        EntityAnalysis
    },
    mounted() {
      //Call autotype - requires context so that we can access refs as they're not available in callbacks 
      this.autoTypeNoErrors("Hello, I'm Lewis!", this);
      this.autoTypeNoErrors(" A software developer based in East London.", this);
      this.autoTypeNoErrors(" I have been writing software professionally since July 2016", this);
      this.autoTypeNoErrors(" and received a Master's degree in Computer Science from the University of Kent.", this);
    },
    methods: {
     /**
      * Enter text into the demo-text-area in EntityAnalysis then call analyseContentOfTextArea once finished
      */
      autoTypeNoErrors(text, ctx){
        $('#demo-text-area')
          .typetype(text, {
            t: 40,
            e: 0,
            callback: function() {
              ctx.$refs.ea.analyseContentOfTextArea()
            }
          });
      }
    }
  }
</script>
